(function guideScrappedPage() {
  $(() => {
    const $accordionTitle = $('.accordion-navigation.open .faqSection');
    const $accordionAnswer = $('.accordion-navigation.open .faqReponse');

    $accordionAnswer.removeClass('active');

    const toggleAccordion = (target) => {
      const $target = $(target);
      const $targetChevron = $target.parent().find('.fleche');
      const $targetRelatedTitle = $target.parent().find('.faqSection');

      if ($(target).hasClass('active')) {
        $target.removeClass('active');
        $targetChevron.removeClass('open');
        $targetRelatedTitle.attr('aria-expanded', false);
        return;
      }

      $accordionAnswer.removeClass('active');
      $accordionAnswer.parent().find('.fleche').removeClass('open');
      $accordionAnswer.parent().find('.faqSection').attr('aria-expanded', false);
      $target.toggleClass('active');
      $targetChevron.toggleClass('open');
      $targetRelatedTitle.attr('aria-expanded', $(target).hasClass('active'));
    };

    $accordionTitle.on('click', (e) => {
      e.preventDefault();
      toggleAccordion($(e.currentTarget).attr('href'));
    });
  });
})();
